import { Component, OnInit } from '@angular/core';
import { ImpactMatrixService } from './service/impact-matrix.service';
import { forkJoin } from 'rxjs';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

export interface impactMatrixHeader {
	id: number;
	name: string;
	impact: number;
}
export interface urgencyMatrixHeader {
	id: number;
	name: string;
	urgency: number;
}

export interface priorityMatrix {
	id: number;
	value: number;
	id_impact: number;
	id_urgency: number;
	impact: number;
	urgency: number;
}

@Component({
	selector: 'register-form-impact-matrix',
	templateUrl: './impact-matrix.component.html',
	styleUrl: './impact-matrix.component.scss',
})
export class ImpactMatrixComponent implements OnInit {
	icons = {
		faTimes: faTimes,
	};

	labels: LabelsInterface = {
		lbl_geral_severidade: '',
		lbl_geral_impacto: '',
		lbl_geral_urgencia: '',
		lbl_geral_atualizar: '',
		lbl_nova_linha: '',
		lbl_nova_coluna: '',
		lbl_adicao_impacto_urgencia_severidade_relacionamento: '',
		lbl_preencha_todos_campos: '',
		lbl_geral_preencha_impacto: '',
		lbl_geral_preencha_urgencia: '',
		lbl_an_errour_occour: '',
		lbl_successful_updated: '',
		lbl_voce_atingiu_limite_adicoes: '',
		lbl_geral_preencha_severidade: '',
		lbl_clique_entre_linhas_colunas_adicionar_nova: '',
	};
	labelsIAC: iacOptionInterface[] = [];

	constructor(
		private ImpactMatrixService: ImpactMatrixService,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService
	) {}

	isLoadingLabels = true;
	isLoadingMatrix = true;
	isUpdatingMatrix = false;

	impactMatrixHeader: impactMatrixHeader[] = [];
	urgencyMatrixHeader: urgencyMatrixHeader[] = [];
	priorityMatrix: priorityMatrix[][] = [];

	onHoldToDeleteImpact: impactMatrixHeader[] = [];
	onHoldToDeleteUrgency: urgencyMatrixHeader[] = [];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			for (const label of Object.keys(labels)) {
				const newIAC: iacOptionInterface = {
					name: labels[label],
					value: label,
					secondName: label,
				};

				this.labelsIAC.push(newIAC);
			}
			this.isLoadingLabels = false;
		});

		this.ImpactMatrixService.getImpactMatrix().subscribe((impactMatrix) => {
			this.impactMatrixHeader = impactMatrix.impact;
			this.urgencyMatrixHeader = impactMatrix.urgency;
			this.priorityMatrix = impactMatrix.priority;

			this.isLoadingMatrix = false;
		});
	}

	addImpact(index: number): void {
		if (this.impactMatrixHeader.length >= 5) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_voce_atingiu_limite_adicoes);
			return;
		}
		this.impactMatrixHeader.splice(index, 0, { id: -1, name: '', impact: this.impactMatrixHeader.length + 1 });
		for (const line of this.priorityMatrix) {
			line.splice(index, 0, { id: -1, value: undefined, id_impact: -1, id_urgency: -1, impact: -1, urgency: -1 });
		}
	}

	addUrgency(index: number): void {
		if (this.urgencyMatrixHeader.length >= 5) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_voce_atingiu_limite_adicoes);
			return;
		}
		this.urgencyMatrixHeader.splice(index, 0, { id: -1, name: '', urgency: this.urgencyMatrixHeader.length + 1 });
		this.priorityMatrix.splice(index, 0, []);
		this.impactMatrixHeader.forEach(() => {
			this.priorityMatrix[index].push({ id: -1, value: undefined, id_impact: -1, id_urgency: -1, impact: -1, urgency: -1 });
		});
	}

	removeImpact(index: number): void {
		this.onHoldToDeleteImpact.push(this.impactMatrixHeader[index]);
		this.impactMatrixHeader.splice(index, 1);
		for (const line of this.priorityMatrix) {
			line.splice(index, 1);
		}
	}

	removeUrgency(index: number): void {
		this.onHoldToDeleteUrgency.push(this.urgencyMatrixHeader[index]);
		this.urgencyMatrixHeader.splice(index, 1);
		this.priorityMatrix.splice(index, 1);
	}

	updateImpactMatrix(): void {
		if (!this.checkFulfillForm() || this.isUpdatingMatrix) return;
		this.isUpdatingMatrix = true;

		this.ImpactMatrixService.putImpactMatrix(
			this.impactMatrixHeader,
			this.onHoldToDeleteImpact,
			this.urgencyMatrixHeader,
			this.onHoldToDeleteUrgency,
			this.priorityMatrix
		).subscribe({
			next: (res) => {
				this.onHoldToDeleteImpact = [];
				this.onHoldToDeleteUrgency = [];

				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			},
			error: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
			},
			complete: () => {
				this.isUpdatingMatrix = false;
			},
		});
	}

	checkFulfillForm(): boolean {
		for (let index = 0; index < this.impactMatrixHeader.length; index++) {
			const impact = this.impactMatrixHeader[index];
			if (impact.name.trim() != '') continue;
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_impacto);
			return false;
		}

		for (let index = 0; index < this.urgencyMatrixHeader.length; index++) {
			const urgency = this.urgencyMatrixHeader[index];
			if (urgency.name.trim() != '') continue;
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_urgencia);
			return false;
		}

		for (let index = 0; index < this.impactMatrixHeader.length; index++) {
			for (let index_ = 0; index_ < this.urgencyMatrixHeader.length; index_++) {
				const severity = this.priorityMatrix[index_][index];
				if (severity.value != undefined) continue;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_severidade);
				return false;
			}
		}

		return true;
	}
}
